<template>
  <div>
    <div class="d-flex align-center justify-space-between px-4 pb-2 pt-2">
      <div
        v-if="['video', 'voice'].includes(channel) && ($store.state.support.OT.shareScreen && $organization.allowWidgetScreenSharing() && btnPrimaryConfig.data)"
        @click="publishScreen()"
      >
        <v-badge
          :color="btnPrimaryConfig.data.btn"
          :class="$store.state.storage.device.screen ? 'active-badge' : ''"
          bordered
          overlap
        >
          <div slot="badge" >
            <Icon
              :width="12"
              :height="12"
              :color="btnPrimaryConfig.data.text"
              :icon="'close'"
            />
          </div>
          <v-btn
            small
            elevation="0"
            fab
            :color="$store.state.storage.device.screen ? btnPrimaryConfig.data.btn : 'white'"
          >
            <Icon
              :width="25"
              :height="25"
              :color="$store.state.storage.device.screen ? btnPrimaryConfig.data.text : '#666'"
              :icon="'monitor-share'"
            />
          </v-btn>
        </v-badge>
      </div>

      <div
        v-if="$organization.rocioRecommendation() && btnPrimaryConfig.data"
        @click="toggleRecommendation()"
      >
        <v-badge
          :color="btnPrimaryConfig.data.btn"
          :content="$parent.recommendation.unreadRecommendation ? $parent.recommendation.unreadRecommendation : ''"
          :class="$parent.recommendation.unreadRecommendation || $parent.recommendation.show ? 'active-badge' : ''"
          bordered
          overlap
        >
          <div
            slot="badge"
            v-if="$parent.recommendation && $parent.recommendation.show"
          >
            <Icon
              :width="12"
              :height="12"
              :color="btnPrimaryConfig.data.text"
              :icon="'close'"
            />
          </div>
          <v-btn
            small
            elevation="0"
            fab
            :color="$parent.recommendation.show ? btnPrimaryConfig.data.btn : 'white'"
          >
            <Icon
              :width="24"
              :color="$parent.recommendation.show ? btnPrimaryConfig.data.text : '#666'"
              :icon="'star-box-outline'"
            />
          </v-btn>
        </v-badge>
      </div>

      <div
        v-if="['video', 'voice'].includes(channel) && $organization.allowChatForUser() && btnPrimaryConfig.data"
        @click="toggleChat()"
      >
        <v-badge
          :color="btnPrimaryConfig.data.btn"
          :content="$parent.chat.unreadMessages ? $parent.chat.unreadMessages : ''"
          :class="$parent.chat.unreadMessages || $parent.chat.show ? 'active-badge' : ''"
          bordered
          overlap
        >
          <div
            slot="badge"
            v-if="$parent.chat && $parent.chat.show"
          >
            <Icon
              :width="12"
              :height="12"
              :color="btnPrimaryConfig.data.text"
              :icon="'close'"
            />
          </div>
          <v-btn
            small
            elevation="0"
            fab
            :color="$parent.chat.show ? btnPrimaryConfig.data.btn : 'white'"
          >
            <Icon
              :width="24"
              :color="$parent.chat.show ? btnPrimaryConfig.data.text : '#666'"
              :icon="'android-messages'"
            />
          </v-btn>
        </v-badge>
      </div>

      <div v-if="['video'].includes(channel) && btnPrimaryConfig.data && videoProcessorEnabled">
        <v-btn
          small
          elevation="0"
          fab
          :color="filtersActive ? btnPrimaryConfig.data.btn : 'white'"
          @click="toggleFilters()"
          :disabled="!publisherCreated"
        >
          <Icon
            :width="22"
            :color="filtersActive ? btnPrimaryConfig.data.text : '#666'"
            :icon="'tune'"
          />
        </v-btn>
      </div>

      <div v-if="['video', 'voice'].includes(channel) && btnPrimaryConfig.data">
        <v-btn
          small
          elevation="0"
          fab
          :color="$store.state.storage.device.microphone ? btnPrimaryConfig.data.btn : 'white'"
          @click="publishAudio(!$store.state.storage.device.microphone)"
          :disabled="!publisherCreated"
        >
          <Icon
            :width="24"
            :color="$store.state.storage.device.microphone ? btnPrimaryConfig.data.text : '#666'"
            :icon="$store.state.storage.device.microphone ? 'microphone-outline' : 'microphone-off'"
          />
        </v-btn>
      </div>

      <div v-if="['video'].includes(channel) && btnPrimaryConfig.data">
        <v-btn
          small
          elevation="0"
          fab
          :color="$store.state.storage.device.camera ? btnPrimaryConfig.data.btn : 'white'"
          @click="publishVideo(!$store.state.storage.device.camera)"
          :disabled="!publisherCreated"
        >
          <Icon
            :width="24"
            :color="$store.state.storage.device.camera ? btnPrimaryConfig.data.text : '#666'"
            :icon="$store.state.storage.device.camera ? 'video-outline' : 'video-off'"
          />
        </v-btn>
      </div>

      <div v-if="['video'].includes(channel) && this.$widget.getDevice().mobile">
        <v-btn
          small
          elevation="0"
          fab
          @click="cycleVideo()"
          :disabled="!$store.state.storage.device.camera || !publisherCreated"
          color="white"
        >
          <Icon
            :width="25"
            :height="25"
            :color="'#666'"
            :icon="'camera-flip-outline'"
          />
        </v-btn>
      </div>

      <div v-if="['video', 'voice'].includes(channel)">
        <v-btn
          small
          elevation="0"
          rounded
          color="#FF0000"
          :dark="!button.finishSession.loading"
          :loading="button.finishSession.loading"
          :disabled="button.finishSession.disabled"
          @click="$refs.confirm.toggleConfirm()"
          width="60"
          height="40"
        >
          <Icon
            :width="25"
            :height="25"
            :color="'#fff'"
            :icon="'phone-off-outline'"
          />
        </v-btn>
      </div>
      <div class="ml-auto mr-auto" v-else-if="['chat'].includes(channel)">
        <v-btn
          small
          elevation="0"
          rounded
          color="#FF0000"
          :dark="!button.finishSession.loading"
          :loading="button.finishSession.loading"
          :disabled="button.finishSession.disabled"
          @click="$refs.confirm.toggleConfirm()"
          height="30"
          class="text-none"
          :style="{ letterSpacing: 'normal', borderRadius: '8px'}"
        >
          Terminar conversación
        </v-btn>
      </div>
    </div>
    <Confirm
      ref="confirm"
      :title="$t('session.endCall.title')"
      :detail="$t('session.endCall.detail')"
      :action="$t('session.endCall.action')"
      @confirmHandler="finishSession"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  components: {
    Confirm: () => import(/* webpackPrefetch: true */ '@/components/Confirm.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    publisherCreated: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      channel: state => state.channel
    }),
    btnPrimaryConfig () {
      return this.$organization.btnPrimaryConfig()
    },
    filtersActive () {
      const vp = this.$store.state.videoProcessor
      return !!(vp && (vp.backgroundFilter || vp.colorFilter || vp.nsfwDetection))
    },
    videoProcessorEnabled () {
      const vpConfig = this.$organization.videoProcessorConfig()
      return vpConfig.isActive && vpConfig.data.backgrounds?.enabled === true
    }
  }
})
export default class Options extends Vue {
  data () {
    return {
      button: {
        finishSession: {
          loading: false,
          disabled: false
        }
      },
    }
  }

  mounted () {
    this.openTok.detectSupportedShareScreen()
  }

  toggleButton (button) {
    this.button[button].loading = !this.button[button].loading
    this.button[button].disabled = !this.button[button].disabled
  }

   toggleRecommendation () {
    this.saveAnalitycsEvent('Botón para activar/desactivar recomendaciones')
    this.$emit('toggleRecommendation')
  }

  toggleFilters () {
    this.saveAnalitycsEvent('Botón para activar/desactivar efectos de video')
    this.$emit('toggleFilters')
  }

  toggleChat () {
    this.saveAnalitycsEvent('Botón para activar/desactivar chat')
    this.$emit('toggleChat')
  }

  cycleVideo () {
    this.$emit('cycleVideo')
  }

  publishScreen () {
    this.saveAnalitycsEvent('Botón para activar/desactivar compartir pantalla')
    this.$emit('publishScreen')
  }

  publishVideo (publish) {
    const activo = (publish) ? 'Activar' : 'Desactivar'
    this.saveAnalitycsEvent(`Botón para ${activo} el video`)
    this.$emit('publishVideo', publish)
  }

  publishAudio (publish) {
    const activo = (publish) ? 'Activar' : 'Desactivar'
    this.saveAnalitycsEvent(`Botón para ${activo} el micrófono`)
    this.$emit('publishAudio', publish)
  }

  finishSession () {
    this.$emit('finishSession', 'call-options')
  }

  saveAnalitycsEvent (action) {
    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action,
      detail: `El cliente presionó el ${action}`,
      actionType: 'SVAH',
      functionality: 7,
      historyInteractionType: 'OSIFDV'
    })
  }
}
</script>

<style>
.v-badge__wrapper span.v-badge__badge {
  opacity: 0;
  inset: calc(100% - 30px) auto auto calc(100% - 15px) !important;
}

.active-badge .v-badge__wrapper span.v-badge__badge {
  opacity: 1;
  inset: calc(100% - 43px) auto auto calc(100% - 15px) !important;
}
</style>
